import styles from "./InputCard.module.scss";
import { useTranslation } from "react-i18next";
import {
  TextField,
  FormControl,
  FormHelperText,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  FormGroup,
  Checkbox,
  Autocomplete,
  Button,
  FormLabel,
  RadioGroup,
  Radio,
} from "@mui/material";
import { Controller } from "react-hook-form";
import { useCallback, useEffect, useRef, useState } from "react";
import PaymentMethod from "./PaymentMethod";
import { constant } from "../misc/constant";
import Fileuploader from "./Fileuploader";
import _ from "lodash";
import { CheckBox } from "@mui/icons-material";

const InputDonationCard = (props) => {
  const { t } = useTranslation();
  const { hookForm, paymentItmeProps } = props;
  const { control, getValues, setValue, trigger, reset } = hookForm || {};

  const donationAmountArray = [300, 500, 1000, 5000, 10000];

  const isValidConfrimEmail = useCallback((confirmEmail) => {
    const email = getValues("email");
    return email === confirmEmail
      ? true
      : t("Email Confrimation does not match email");
  }, []);

  const isValidYearOfBirth = useCallback((year) => {
    const minYear = 1900;
    const maxYear = new Date().getFullYear();
    return (year >= minYear && year <= maxYear) || !year
      ? true
      : t("Invalid Year of Birth");
  }, []);

  const inputRef = useRef(null);

  const handleChangeDonationAmount = (amount) => {
    setDonationFinalAmount(amount);
    reset({ otherAmount: null });
    inputRef.current.value = null;
  };

  const handleChangeDonationFinalAmount = (amount) => {
    // console.log(amount);
    setDonationFinalAmount(amount);
  };

  const [receipt, setReceipt] = useState(false);
  const [donationFinalAmount, setDonationFinalAmount] = useState(500);

  useEffect(() => {
    if (donationFinalAmount < 100 && receipt === "yes") setReceipt(undefined);
    setValue("donationAmount", donationFinalAmount);
    // console.log(donationFinalAmount);
    setTimeout(() => {
      trigger("otherAmount");
    }, 0);
  }, [donationFinalAmount]);

  useEffect(() => {
    // console.log(receipt);
  }, [receipt]);

  return (
    <div className={`card-view ${styles.card} ${props.xc || ""}`}>
      <div className="container">
        <div className="input-container mt-4">
          <div className="donation-div">
            <div className="amount-div">
              <h1>{t("Donation Amount")}</h1>
              <h3>{`港幣${donationFinalAmount}`}</h3>
            </div>
            <div className="option-div">
              <div>
                {donationAmountArray.map((amount) => (
                  <Button
                    key={_.uniqueId("donation_btn_")}
                    onClick={() => handleChangeDonationAmount(amount)}
                    disableElevation
                    variant="contained"
                    sx={{ marginRight: "12px", marginBottom: "8px" }}
                  >
                    {`$${amount}`}
                  </Button>
                ))}
              </div>
              <div style={{ width: "100%", flex: 1 }}>
                <Controller
                  key="otherAmount"
                  name="otherAmount"
                  control={control}
                  defaultValue={undefined}
                  render={({ field, fieldState: { error } }) => {
                    return (
                      <TextField
                        sx={{ width: "100%" }}
                        label={t("Other Amount")}
                        variant="standard"
                        error={!!error}
                        helperText={error ? error.message : null}
                        InputLabelProps={{ shrink: field.value ? true : false }}
                        type="number"
                        {...field}
                        inputProps={{
                          ref: inputRef,
                          autoComplete: "disabled",
                          min: 0,
                        }}
                        onChange={(event) => {
                          handleChangeDonationFinalAmount(event.target.value);
                          field.onChange(event);
                        }}
                      />
                    );
                  }}
                  rules={{
                    validate: {
                      isValid: (value) => {
                        if (donationFinalAmount >= 50) {
                          // console.log(donationFinalAmount);
                          return true;
                        }
                        return t("Not less than 50");
                      },
                    },
                  }}
                />
              </div>
              <FormControl
                style={{ width: "100%", marginTop: "24px", flex: 1 }}
              >
                <FormLabel>{t("Need receipt")}</FormLabel>
                <RadioGroup
                  row
                  value={receipt}
                  onChange={(e) => setReceipt(e.target.value)}
                >
                  <FormControlLabel
                    value="yes"
                    control={<Radio />}
                    label={t("Yes")}
                    disabled={donationFinalAmount < 100}
                  />
                  <FormControlLabel
                    value="no"
                    control={<Radio />}
                    label={t("No")}
                  />
                </RadioGroup>
              </FormControl>
              {receipt && receipt === "yes" ? (
                <>
                  <div style={{ width: "100%", flex: 1 }}>
                    <Controller
                      key="receiptName"
                      name="receiptName"
                      control={control}
                      defaultValue=""
                      render={({ field, fieldState: { error } }) => (
                        <TextField
                          sx={{ width: "100%" }}
                          label={t("Receipt Name")}
                          variant="standard"
                          error={!!error}
                          helperText={error ? error.message : null}
                          {...field}
                        />
                      )}
                      rules={{
                        validate: {
                          isValid: (value) =>
                            !receipt
                              ? true
                              : value && value !== ""
                              ? true
                              : t("Required"),
                        },
                      }}
                    />
                  </div>
                  <div
                    style={{
                      width: "100%",
                      marginTop: "12px",
                      flex: 1,
                      marginBottom: "12px",
                    }}
                  >
                    <Controller
                      key="receiptAddress"
                      name="receiptAddress"
                      control={control}
                      defaultValue=""
                      render={({ field, fieldState: { error } }) => (
                        <TextField
                          sx={{ width: "100%" }}
                          label={t("Receipt Address")}
                          variant="standard"
                          error={!!error}
                          helperText={t("Receipt HelperText")}
                          {...field}
                        />
                      )}
                      // rules={{
                      //   validate: {
                      //     isValid: (value) => (!receipt ? true : value && value !== "" ? true : t("Required")),
                      //   },
                      // }}
                    />
                  </div>
                </>
              ) : null}
            </div>
          </div>
          <h1 className="mb-1 mt-2">{t("Fill in the information")}</h1>
          <div className="input-div full-width">
            <Controller
              key="prefix"
              name="prefix"
              control={control}
              defaultValue=""
              render={({ field, fieldState: { error } }) => (
                <div className="render-comp">
                  <FormControl
                    variant="standard"
                    sx={{ width: "100%" }}
                    error={!!error}
                  >
                    <InputLabel>{t("Prefix")}</InputLabel>
                    <Select
                      {...field}
                      onChange={(event) => {
                        setValue("prefix", event.target.value);
                        trigger("prefix");
                      }}
                    >
                      {constant.prefixList.map((item) => {
                        const str = t(item);
                        const key = _.uniqueId("menuitem_");
                        return (
                          <MenuItem key={key} value={str}>
                            {str}
                          </MenuItem>
                        );
                      })}
                    </Select>
                    {error ? (
                      <FormHelperText>{error.message}</FormHelperText>
                    ) : null}
                  </FormControl>
                </div>
              )}
              rules={{ required: t("Required") }}
            />
          </div>
          <div className="input-div">
            <Controller
              key="chineseLastname"
              name="chineseLastname"
              control={control}
              defaultValue=""
              render={({ field, fieldState: { error } }) => (
                <TextField
                  sx={{ width: "100%" }}
                  label={t("Chinese lastname")}
                  variant="standard"
                  error={!!error}
                  helperText={error ? error.message : null}
                  {...field}
                />
              )}
            />
          </div>
          <div className="input-div">
            <Controller
              key="chineseFirstname"
              name="chineseFirstname"
              control={control}
              defaultValue=""
              render={({ field, fieldState: { error } }) => (
                <TextField
                  sx={{ width: "100%" }}
                  label={t("Chinese firstname")}
                  variant="standard"
                  error={!!error}
                  helperText={error ? error.message : null}
                  {...field}
                />
              )}
            />
          </div>
          <div className="input-div">
            <Controller
              key="englishLastname"
              name="englishLastname"
              control={control}
              defaultValue=""
              render={({ field, fieldState: { error } }) => (
                <TextField
                  sx={{ width: "100%" }}
                  label={t("English lastname")}
                  variant="standard"
                  error={!!error}
                  helperText={error ? error.message : null}
                  {...field}
                />
              )}
              rules={{ required: t("Required") }}
            />
          </div>
          <div className="input-div">
            <Controller
              key="englishFirstame"
              name="englishFirstame"
              control={control}
              defaultValue=""
              render={({ field, fieldState: { error } }) => (
                <TextField
                  sx={{ width: "100%" }}
                  label={t("English firstname")}
                  variant="standard"
                  error={!!error}
                  helperText={error ? error.message : null}
                  {...field}
                />
              )}
              rules={{ required: t("Required") }}
            />
          </div>
          <div className="input-div full-width">
            <Controller
              key="gender"
              name="gender"
              control={control}
              defaultValue=""
              render={({ field, fieldState: { error } }) => (
                <div className="render-comp">
                  <FormControl
                    variant="standard"
                    sx={{ width: "100%" }}
                    error={!!error}
                  >
                    <InputLabel>{t("Gender")}</InputLabel>
                    <Select
                      {...field}
                      onChange={(event) => {
                        setValue("gender", event.target.value);
                        trigger("gender");
                      }}
                    >
                      {constant.genderList.map((item) => {
                        const str = t(item);
                        const key = _.uniqueId("menuitem_");
                        return (
                          <MenuItem key={key} value={str}>
                            {str}
                          </MenuItem>
                        );
                      })}
                    </Select>
                    {error ? (
                      <FormHelperText>{error.message}</FormHelperText>
                    ) : null}
                  </FormControl>
                </div>
              )}
            />
          </div>
          <div className="input-div">
            <Controller
              key="email"
              name="email"
              control={control}
              defaultValue=""
              render={({ field, fieldState: { error } }) => (
                <TextField
                  sx={{ width: "100%" }}
                  label={t("Email")}
                  variant="standard"
                  error={!!error}
                  helperText={error ? error.message : null}
                  {...field}
                />
              )}
              rules={{
                required: t("Required"),
                pattern: {
                  value: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/,
                  message: t("Invalid email"),
                },
              }}
            />
          </div>
          <div className="input-div">
            <Controller
              key="confirmEmail"
              name="confirmEmail"
              control={control}
              defaultValue=""
              render={({ field, fieldState: { error } }) => (
                <TextField
                  sx={{ width: "100%" }}
                  label={t("Confirm email")}
                  variant="standard"
                  error={!!error}
                  helperText={error ? error.message : null}
                  {...field}
                />
              )}
              rules={{
                required: t("Required"),
                pattern: {
                  value: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/,
                  message: t("Invalid email"),
                },
                validate: {
                  isValid: (value) => isValidConfrimEmail(value),
                },
              }}
            />
          </div>
          {/* <div className="input-div">
            <Controller
              key="phoneType"
              name="phoneType"
              control={control}
              defaultValue=""
              render={({ field, fieldState: { error } }) => (
                <FormControl variant="standard" sx={{ width: "100%" }} error={!!error}>
                  <InputLabel>{t("Phone type")}</InputLabel>
                  <Select
                    {...field}
                    onChange={(event) => {
                      setValue("phoneType", event.target.value);
                      trigger("phoneType");
                    }}
                  >
                    {constant.phoneTypeList.map((item) => {
                      const str = t(item);
                      const key = _.uniqueId("menuitem_");
                      return (
                        <MenuItem key={key} value={str}>
                          {str}
                        </MenuItem>
                      );
                    })}
                  </Select>
                  {error ? <FormHelperText>{error.message}</FormHelperText> : null}
                </FormControl>
              )}
              rules={{ required: t("Required") }}
            />
          </div> */}
          <div className="input-div full-width">
            <Controller
              key="phoneNumber"
              name="phoneNumber"
              control={control}
              defaultValue=""
              render={({ field, fieldState: { error } }) => (
                <TextField
                  sx={{ width: "100%" }}
                  label={t("Phone No.")}
                  variant="standard"
                  {...field}
                  error={!!error}
                  helperText={error ? error.message : null}
                />
              )}
              rules={{
                required: t("Required"),
                pattern: {
                  value: /^[0-9]*$/,
                  message: t("Invalid Phone no."),
                },
                minLength: {
                  value: 8,
                  message: t("Invalid Phone no."),
                },
              }}
            />
          </div>
          <div className="input-div full-width">
            <Controller
              key="birthMonth"
              name="birthMonth"
              control={control}
              defaultValue=""
              render={({ field, fieldState: { error } }) => (
                <div className="render-comp">
                  <FormControl
                    variant="standard"
                    sx={{ width: "100%" }}
                    error={!!error}
                  >
                    <InputLabel>{t("Month of Birth")}</InputLabel>
                    <Select
                      {...field}
                      onChange={(event) => {
                        setValue("birthMonth", event.target.value);
                        trigger("birthMonth");
                      }}
                    >
                      {constant.monthList.map((item) => {
                        const str = t(item);
                        const key = _.uniqueId("menuitem_");
                        return (
                          <MenuItem key={key} value={str}>
                            {str}
                          </MenuItem>
                        );
                      })}
                    </Select>
                    {error ? (
                      <FormHelperText>{error.message}</FormHelperText>
                    ) : null}
                  </FormControl>
                </div>
              )}
            />
          </div>
        </div>
        <h1 className="mb-2">
          {t("Personal Information Collection Statement")}
        </h1>
        <ol className={`${styles.orderlist} mb-8`}>
          <li>
            <div>
              閣下向卓嶺有限公司〔「本機構」〕所提供的資料，包括《個人資料〔私隱〕條例》所指的個人資料，只會用於處理捐款事宜以及分析或統計。除獲本機構授權的人員外，本機構不會將閣下的個人資料轉移給任何第三方。閣下必須向本機構提供完整的資料。如未能提供完整的資料，本機構或無法處理捐款。
            </div>
          </li>
          <li>
            <div>
              閣下提供的個人資料將用作與本機構溝通渠道，將與閣下分享本機構的事務通訊、課程、活動或募捐活動等推廣資訊。閣下若同意接收此等資訊，請於下列接收資訊欄之空格內加上「✔」。
            </div>
          </li>
          <div className="checkbox">
            <Controller
              key="pi-1"
              name="pi-1"
              control={control}
              defaultValue={true}
              render={({ field, fieldState: { error } }) => {
                return (
                  <FormControl component="fieldset" error={error}>
                    <FormGroup>
                      <FormControlLabel
                        control={<Checkbox {...field} defaultChecked />}
                        label="本人同意接收由卓嶺有限公司發出的推廣資訊。"
                      />
                      {error ? (
                        <FormHelperText sx={{ marginBottom: "16px" }}>
                          {error.message}
                        </FormHelperText>
                      ) : null}
                    </FormGroup>
                  </FormControl>
                );
              }}
            />
            <div style={{ fontSize: "11px" }}>
              <i>
                若閣下日後不欲接收本機構的推廣資訊，可電郵至
                <a href="mailto:cs@elite-paradise.tech">
                  {" "}
                  cs@elite-paradise.tech
                </a>
                。
              </i>
            </div>
          </div>
          <li>
            <div>
              如閣下希望查閱或更改個人資料，請連同閣下已登記的姓名、電話號碼、電郵地址資料，電郵至
              <a href="mailto:cs@elite-paradise.tech">
                {" "}
                cs@elite-paradise.tech
              </a>
              。
            </div>
          </li>
        </ol>
        <h1 className="mb-5">{t("Select payment method")}</h1>
        <PaymentMethod xc="mb-2" paymentItmeProps={paymentItmeProps} />
      </div>
    </div>
  );
};

export default InputDonationCard;
